// extracted by mini-css-extract-plugin
export var loadingSpinner = "_13-0";
export var spinnerContainer = "_13-1";